"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pagingState = exports.filterState = exports.filterItem = exports.filteringState = exports.sortState = exports.cellValue = exports.columnData = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columnData = _propTypes.default.shape({
  key: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  filterable: _propTypes.default.bool,
  sortable: _propTypes.default.bool,
  width: _propTypes.default.number,
  headerRenderer: _propTypes.default.func,
  renderer: _propTypes.default.func,
  className: _propTypes.default.string,
  headerClassName: _propTypes.default.string,
  style: _propTypes.default.object,
  headerStyle: _propTypes.default.string
});

exports.columnData = columnData;

var cellValue = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.array, _propTypes.default.bool, _propTypes.default.object, _propTypes.default.node, _propTypes.default.func]);

exports.cellValue = cellValue;

var sortState = _propTypes.default.shape({
  key: _propTypes.default.string,
  direction: _propTypes.default.oneOf(_constants.SORT_DIRECTIONS)
});

exports.sortState = sortState;

var filteringState = _propTypes.default.arrayOf(_propTypes.default.shape({
  key: _propTypes.default.string,
  value: _propTypes.default.arrayOf(_propTypes.default.any)
}));

exports.filteringState = filteringState;

var filterItem = _propTypes.default.shape({
  key: _propTypes.default.string,
  value: _propTypes.default.arrayOf(_propTypes.default.string)
});

exports.filterItem = filterItem;

var filterState = _propTypes.default.arrayOf(filterItem);

exports.filterState = filterState;

var pagingState = _propTypes.default.shape({
  pageSize: _propTypes.default.number,
  currentPage: _propTypes.default.number
});

exports.pagingState = pagingState;